module.exports = __webpack_public_path__ + "img/tengxun_qr.591570e8.jpg";